<div class="card">
    <div class="card-header">
        <h1 class="mb-0">Notas de crédito (NCRE)</h1>
    </div>

    <div class="card-body">

        <div class="mb-4 p-3 border rounded bg-light">
            <h6 class="fw-bold text-primary mb-3">1. Seleccionar Cliente</h6>

            <div class="row">
                <div class="col-md-8">
                    <label class="form-label">Cliente</label>
                    <div class="input-group input-group-sm">
                        <app-input-autocomplete
                            [ruleToDisabled]="clients.length == 0"
                            [allBorderRadius]="true"
                            [inputs]="client"
                            [placeholder]="'Ingresa el NIT, código o nombre de un cliente'"
                            [filterElements]="client.filterElements"
                            [typeElements]="'client'"
                            (inputMethod)="writeClient()"
                            (changeStatus)="selectClient($event.filterElement)"
                            [custom]="true">

                            <ng-template #itemsTemplate let-filter>
                                <div items>
                                    <h5 class="text-info m-0">{{ filter.name }}</h5>
                                    <span style="color:white;">
                                        Código: <b>{{ filter.code }}</b> ·
                                        NIT: <b>{{ filter.nit }}</b>
                                    </span>
                                </div>
                            </ng-template>

                        </app-input-autocomplete>
                    </div>
                </div>

                <div class="col-md-4" *ngIf="clientSelected">
                    <div class="border rounded p-2 bg-white shadow-sm">
                        <div><strong>Cliente:</strong> {{ clientSelected.name }}</div>
                        <div><strong>Código:</strong> {{ clientSelected.code }}</div>
                        <div><strong>NIT:</strong> {{ clientSelected.nit }}</div>
                    </div>
                </div>
            </div>
        </div>


        <div class="mb-4 p-3 border rounded bg-light" *ngIf="clientSelected">
            <h6 class="fw-bold text-primary mb-3">2. Seleccionar Factura</h6>

            <div class="row mb-3" id="options-other-filters">
                <div class="col-sm form-group">
                    <label for="filterVendors" class="form-label">Filtrar</label>
                    <div class="input-group input-group-sm">
                        <input type="text" id="filter" (input)="searching()" [(ngModel)]="filterWord"
                            placeholder="Filtra factura por numero o serie" name="filter" class="form-control">
                        <button class="btn btn-primary" (click)="searching()">
                            <i class="fa fa-search"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div *ngIf="loadingInvoices" class="text-center my-3">
                <i class="fa fa-spinner fa-spin"></i> Cargando facturas...
            </div>

            <div class="table-responsive" *ngIf="!loadingInvoices && invoices?.length > 0" style="max-height: 400px;">
                <table class="table table-bordered table-hover table-sm align-middle">
                    <thead class="table-light">
                        <tr class="sticky-top">
                            <th class="text-center">Sel.</th>
                            <th class="text-center">Fecha</th>
                            <th class="text-center">Serie</th>
                            <th class="text-center">Número</th>
                            <th class="text-end">Monto factura</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let invoiceD of invoices"
                            (click)="onInvoiceSelected(invoiceD)"
                            [class.table-active]="selectedInvoice?.id === invoiceD.id"
                            style="cursor: pointer;">

                            <td class="text-center">
                                <input type="radio"
                                       name="selectedInvoice"
                                       [checked]="selectedInvoice?.id === invoiceD.id"
                                       (change)="onInvoiceSelected(invoiceD)" />
                            </td>

                            <td class="text-center">{{ invoiceD.date | date:'dd/MM/yyyy' }}</td>
                            <td class="text-center">{{ invoiceD.series }}</td>
                            <td class="text-center">{{ invoiceD.number }}</td>

                            <td class="text-end">
                                {{ getCurrencyPrefix(invoiceD) }}
                                {{ getInvoiceAmount(invoiceD) | number:'1.2-2' }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div *ngIf="!loadingInvoices && invoices.length === 0" class="alert alert-info">
                El cliente no tiene facturas aplicables.
            </div>
        </div>


        <div *ngIf="selectedInvoice" class="mb-4 p-3 border rounded bg-white shadow-sm">
            <h6 class="fw-bold text-primary">3. Factura seleccionada</h6>

            <p><strong>Serie y número:</strong> {{ selectedInvoice.series }} - {{ selectedInvoice.number }}</p>
            <p><strong>Fecha:</strong> {{ selectedInvoice.date | date:'dd/MM/yyyy' }}</p>
            <p>
                <strong>Monto factura:</strong>
                {{ getCurrencyPrefix(selectedInvoice) }}
                {{ getInvoiceAmount(selectedInvoice) | number:'1.2-2' }}
            </p>
            <div class="mt-2 p-2 border rounded bg-light">
                <div *ngIf="loadingNcreQuantity">
                    <i class="fa fa-spinner fa-spin"></i> Consultando notas de crédito...
                </div>

                <div *ngIf="!loadingNcreQuantity">
                    <p class="mb-1">
                        <strong>NCRE realizadas:</strong>
                        {{ ncreQuantity?.quantity ?? 0 }}
                    </p>

                    <p class="mb-0">
                        <strong>Total en NCRE:</strong>
                        {{ getCurrencyPrefix(selectedInvoice) }}
                        {{ (ncreQuantity?.total ?? 0) | number:'1.2-2' }}
                    </p>
                </div>
            </div>

            <div class="mt-3" *ngIf="invoiceDetails?.length > 0">
                <h6 class="text-secondary">Detalle de factura</h6>

                <table class="table table-sm table-bordered">
                    <thead class="table-light">
                        <tr>
                            <th>Código</th>
                            <th>Producto</th>
                            <th class="text-center">Cantidad</th>
                            <th class="text-end">Precio</th>
                            <th class="text-end">Total</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let d of invoiceDetails">
                            <td>{{ d.productData.code }}</td>
                            <td>{{ d.productData.name }}</td>
                            <td class="text-center">{{ d.quantity }}</td>

                            <td class="text-end">
                                {{ getCurrencyPrefix(selectedInvoice) }}
                                {{ (d.price + d.taxes) | number:'1.2-2' }}
                            </td>

                            <td class="text-end">
                                {{ getCurrencyPrefix(selectedInvoice) }}
                                {{ ((d.price + d.taxes) * d.quantity) | number:'1.2-2' }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>


        <div *ngIf="selectedInvoice" class="mb-4 p-3 border rounded bg-light">
            <h6 class="fw-bold text-primary mb-3">4. Datos de la Nota de Crédito</h6>

            <div class="row g-3">
                <div class="col-md-4">
                    <div class="custom-radio-switch mb-2" (click)="setCreditType('discount')">
                        <input type="radio" name="creditType" [checked]="creditType === 'discount'">
                        <span class="switch"></span>
                        <span class="label">Descuento</span>
                    </div>

                    <div class="custom-radio-switch" (click)="setCreditType('return')">
                        <input type="radio" name="creditType" [checked]="creditType === 'return'">
                        <span class="switch"></span>
                        <span class="label">Devolución</span>
                    </div>
                </div>

                <div class="col-md-3">
                    <label class="form-label">Fecha</label>
                    <input type="date" class="form-control form-control-sm" [(ngModel)]="creditNoteDate">
                </div>

                <div class="col-md-5">
                    <label class="form-label">Descripción</label>
                    <input type="text" class="form-control form-control-sm" [(ngModel)]="creditNoteDescription">
                </div>
            </div>
        </div>


        <div *ngIf="creditType" class="mb-4 p-3 border rounded bg-white shadow-sm">
            <h6 class="fw-bold text-primary mb-3">5. Productos agregados a la Nota</h6>

            <div class="row g-3 align-items-end">
                <div class="col-sm-4">
                    <label class="form-label">Producto/Servicio</label>
                    <div class="input-group">
                        <app-input-autocomplete
                            [allBorderRadius]="true"
                            [inputs]="inputs.product"
                            [placeholder]="'Ingresa un producto'"
                            [filterElements]="filterProducts"
                            [typeElements]="'product-order'"
                            (inputMethod)="writeProduct($event.event)"
                            (changeStatus)="checkProduct($event.filterElement)"
                            (getTitle)="$event.filterElement.title = $event.filterElement.code + ' - ' + $event.filterElement.name">
                        </app-input-autocomplete>
                    </div>
                </div>

                <div class="col-sm-2">
                    <label class="form-label">Cantidad</label>
                    <input type="number" class="form-control form-control-sm"
                           [(ngModel)]="quantity" (input)="calculateLineTotal()">
                </div>

                <div class="col-sm-2">
                    <label class="form-label">Precio unidad</label>
                    <input type="number" class="form-control form-control-sm"
                           [(ngModel)]="unitPrice" (input)="calculateLineTotal()">
                </div>

                <div class="col-sm-2">
                    <label class="form-label">Total</label>
                    <div class="fw-bold">
                        {{ getCurrencyPrefix(selectedInvoice) }}
                        {{ lineTotal | number:'1.2-2' }}
                    </div>
                </div>

                <div class="col-sm-2">
                    <button class="btn btn-outline-primary w-100" (click)="addProduct()">
                        <i class="fa fa-plus"></i> Agregar
                    </button>
                </div>
            </div>
        </div>


        <div *ngIf="productsList.length > 0" class="mb-4 p-3 border rounded bg-light">
            <h6 class="fw-bold text-primary mb-3">6. Productos incluidos en la Nota</h6>

            <table class="table table-sm table-bordered">
                <thead class="table-light">
                    <tr>
                        <th>Producto</th>
                        <th class="text-center">Cantidad</th>
                        <th class="text-end">Precio</th>
                        <th class="text-end">Total</th>
                        <th class="text-center">Acciones</th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let p of productsList; let i = index">
                        <td>{{ p.product.code }} - {{ p.product.name }}</td>
                        <td class="text-center">{{ p.quantity }}</td>

                        <td class="text-end">
                            {{ getCurrencyPrefix(selectedInvoice) }}
                            {{ p.unitPrice | number:'1.2-2' }}
                        </td>

                        <td class="text-end">
                            {{ getCurrencyPrefix(selectedInvoice) }}
                            {{ p.total | number:'1.2-2' }}
                        </td>

                        <td class="text-center">
                            <button class="btn btn-sm btn-danger" (click)="removeProduct(i)">
                                <i class="fa fa-trash"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>


        <div class="mt-4 text-end" *ngIf="creditType && selectedInvoice">
            <button class="btn btn-success px-4 py-2" (click)="submitCreditNote()">
                <i class="fa fa-check"></i> Generar Nota de Crédito
            </button>
        </div>

    </div>
</div>
